import { createClient, isSupabaseConfigured } from './lib/supabase';

export { isSupabaseConfigured };

/** Shared Supabase client for data sync (same singleton as auth). */
export const supabase = isSupabaseConfigured() ? createClient() : null;
